import React from "react";

function SwitchItem(props){
    return <div className="switch-item">{props.children}</div>
} export default SwitchItem;